
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carreiras",
      function () {
        return require("private-next-pages/carreiras/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carreiras"])
      });
    }
  